import React from 'react';
import { useSelector } from 'react-redux';

import IconButton from '@mui/material/IconButton';
import TooltipForButton from 'components/mui/Tooltip/TooltipForButton';

import { isAdminSelector } from 'domain/env';

import useTrashCategoryActions from './useTrashCategoryActions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

interface TrashCategoryActionsProps {
  isTrashCategory: boolean;
  disabled: boolean;
}

const TrashCategoryActions: React.FC<TrashCategoryActionsProps> = ({ isTrashCategory, disabled }) => {
  const isAdmin = useSelector(isAdminSelector);
  const { handlePermanentlyDeleteAll } = useTrashCategoryActions();

  return isTrashCategory && isAdmin ? (
    <TooltipForButton t={{ id: 'tooltip.company.bar.permanentlyDeleteAll', defaultMessage: 'Permanently delete all' }}>
      <IconButton color="error" onClick={handlePermanentlyDeleteAll} disabled={disabled}>
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </TooltipForButton>
  ) : null;
};

export default TrashCategoryActions;
